//
window.left_eye_bot =  [
  263, 249, 390, 373, 374, 380, 381, 382, 362
];

window.left_eye_top = [
  263, 466, 388, 387, 386, 385, 384, 398, 362
];

window.right_eye_bot = [
  33, 7, 163, 144, 145, 153, 154, 155, 133,
];

window.right_eye_top = [
  33, 246, 161, 160, 159, 158, 157, 173, 133,
];
